import {React, useEffect, useState, useContext} from 'react'
import PriceAgricultureParityFormMiscellaneousDataAndMiscellaneousData from '../../../../Components/PriceAgricultureParityFormMiscellaneousDataAndMiscellaneousData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {handleUserLevelAccessPermissions,getAllYears,validateRoles,isNumeric,getNextYear} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import othersData from '../../../../others.json'; 

function PriceAgricultureParityFormMiscellaneous() {


    const [years, setYears] = useState([]);
   const [agricultureCode, setAgricultureCode] = useState('');
    const [yearName, setYearName] = useState('');
    const [agricultureItem, setAgricultureItem] = useState([]);
    const [priceAgrilcultureData, setPriceAgrilcultureData] = useState([]);
    const [previousYearArea, setPreviousYearArea ] = useState('');
    const [currentYearArea , setCurrentYearArea  ] = useState('');
    // const [payload, setPayload] = useState([]);
    // const [isDivision, setIsDivision ] = useState(false);
    const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const navigate = useNavigate();
    const storedLanguage = localStorage.getItem('language');
    const config = getAuthHeaders();



   useEffect(() => {
        
        const level =  handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level)
       
        const getYearList =()=>{
            setYears(getAllYears());
          }


      // All Agriculture Items list
      const getAgricultureItems  = async () => {
      
          try {
              const response = await axios.get(`${API_URL}api/otherPrices/getAgriculturalParityMiscellaneous`, config);
              const allItems= response.data;
              if (allItems.status) {
                    setAgricultureItem(allItems.data.GroupCodes);
                    showLoading(false);
              }
          } catch (error) {
          console.error(error);
          showLoading(false);
          }
      };

       
       const userRole = async () => {
        //   showLoading(true)
          try {
            const role = await validateRoles(decode_token)
            if (role) {
                  getYearList();
                  getAgricultureItems()
              }else {
          
              alert("You are not an authorized user to capture the data for Pricing");
              navigate("/dashboard");
            }
          } catch (error) {
            console.log(error);
            showLoading(false)
          }
        }
      userRole();
  
         
      },[]);



const handleDropdownChange=(e)=>{

switch(e.target.name){
    case 'agricultureCode':
        setAgricultureCode(e.target.value)
        handleAgricultureOnChangeData(e.target.value)
        setYearName('')
        
    break;

    case 'currentFinancialYear':
    setYearName(e.target.value)

    let postData={
        itemTypeCode: agricultureCode,
        CurrentYear: e.target.value,
        PreviousYear:e.target.value-1
    }
        onChangePriceAgricultureParityFormMiscellaneousData(postData)
        
    break;
    default:
    console.log("switch case are not match");
break;

}
}


//Handle Get Agriculture on Change Data
const handleAgricultureOnChangeData=async(itemCode)=>{

        showLoading(true);
        const postData={itemCode: itemCode}
        try {
          // Make API call to fetch data
          const response = await axios.post(`${API_URL}api/otherPrices/AgriculturalParityMiscellaneousAndElectricity`, postData, config);
         if (response.data.status) {
            setPriceAgrilcultureData(response.data.data.GroupCodes);
        //     setPayload(response.data.data.payload);
            showLoading(false);
          }
        } catch (error) {
          console.error('Error posting data:', error);
          showLoading(false);
        }
    }




//Handle Get all data on change
const onChangePriceAgricultureParityFormMiscellaneousData=async(postData)=>{

        showLoading(true);
  
        try {
          // Make API call to fetch data
          const response = await axios.post(`${API_URL}api/otherPrices/getAllAgriculturalParityMiscellaneousAndElectricity`, postData, config);
           
          if (response.data.status) {
              setPriceAgrilcultureData(response.data.data.GroupCodes);
              showLoading(false);
          }
        } catch (error) {
          console.error('Error posting data:', error);
          showLoading(false);
        }

}


//hande reset from Data
const resetFormData=()=>{
    setAgricultureCode('')
    setYearName('')
    setPriceAgrilcultureData([])
}


 //handle submit Form Validation
 const handleSubmitForm=()=>{
  if(agricultureCode===''){
   toast.error("Please Select Agriculture Type", messages.COLOR_RED);
   return false;
  }

   if(yearName === '') {
       toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
       return false;
   }
return true;
}

//Handle Reset Form
const handleResetForm=()=>{
  resetFormData();
  setPreviousYearArea('')
  setCurrentYearArea('')
}

//Handle on Change Event 
const handleOnChange=(e)=>{
if(!isNumeric(e.target.value)){
   toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
 return false;
 }
 if(e.target.name==='previousYearArea'){
  setPreviousYearArea(e.target.value)
 }

 if(e.target.name==='currentYearArea'){
  setCurrentYearArea(e.target.value)
 }

}

  return (
    <>
   
    <ToastContainer/>
    <GlobalLoading />
      <div className="container-fluid py-3">
       <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
         <div className="row align-items-center">
             <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? othersData.hi.PRI_AGRICULTURE_PRORITY_FORMTWO : othersData.en.PRI_AGRICULTURE_PRORITY_FORMTWO }} />        
             </h4>
             <div className="row align-items-center">
             {/* {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                     <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
             } */}
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? othersData.hi.AGRICULTURE_ITEM_TYPE : othersData.en.AGRICULTURE_ITEM_TYPE}:</label>
                     <select
                      name="agricultureCode"
                      id="agricultureCode"
                      className="form-select"
                     onChange={handleDropdownChange}
                     value={agricultureCode}
                    >
                   <option value="" disabled>Select Agriculture</option>
                   {agricultureItem &&
                     agricultureItem
                       .map((ele, index) => (
                         <option key={index} value={ele.itemTitleType}>
                           {ele.itemTitleName}
                         </option>
                       ))}
                 </select>
                 </div>

                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? othersData.hi.CURRENT_FINANCIAL_YEAR : othersData.en.CURRENT_FINANCIAL_YEAR}:	</label>
                     <select  name="currentFinancialYear" 
                      className="form-select" 
                      onChange={handleDropdownChange}  
                       value={yearName} >
                         <option value="" disabled>Select Year</option>
                         {years && years.map((ele, index) => (
                           <option key={index} value={ele}>
                           {getNextYear(ele)}
                           </option>
                         )) }
                   </select>
                 </div>
                

                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? othersData.hi.PREVIOUS_FINANCIAL_YEAR : othersData.en.PREVIOUS_FINANCIAL_YEAR}:	</label>
                   <input 
                   type="text" 
                   className="form-control"
                   value={ yearName && getNextYear(yearName-1)}
                   disabled
                   />
                 </div>
 
                
             </div>
         </div>
       </div>
     </div>
 
     <div className="card mx-3 mb-3">
         

         {
          priceAgrilcultureData.length > 0 ? (
          <PriceAgricultureParityFormMiscellaneousDataAndMiscellaneousData 
           type="PriceAgricultureParityFormMiscellaneous" 
           config={config} 
          resetFormData={resetFormData}  
          userInfoObject={buttonAccess}  
          yearName={yearName} 
          priceAgrilcultureData={priceAgrilcultureData}
          agricultureCode={agricultureCode}
          url='agriculturalParityMiscellaneousAndElectricitySaveToDB'
          storedLanguage={storedLanguage}
          othersData={othersData}
          />
        ) : (
          <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
            <thead>
              <tr>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.SERIAL_NO : othersData.en.SERIAL_NO}</th>
            <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.ITEM_NAME : othersData.en.ITEM_NAME}</th>
            <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.PREVIOUS_YEAR_AREA : othersData.en.PREVIOUS_YEAR_AREA}</th>
            <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.CURRENT_YEAR_AREA : othersData.en.CURRENT_YEAR_AREA}</th>
            <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.REMARKS : othersData.en.REMARKS}</th>
              
              </tr>
            </thead>
            <tbody>
              
            <tr>
              <td>1</td>
            <td>
              <input 
              type="text" 
              className="form-control" 
              name="marketName_1" 
              id="marketName_1" 
              readOnly
              />
            </td>

              <td>
                <input 
                type="text" 
                className="form-control" 
                name="previousYearArea" 
                id="previousYearArea" 
                value={previousYearArea}
                onChange={(e)=>handleOnChange(e)}
                />
               </td>

              <td>
                <input 
                type="text" 
                className="form-control" 
                name="currentYearArea" 
                id="currentYearArea" 
                value={currentYearArea}
                onChange={(e)=>handleOnChange(e)}
                 />
              </td>
              <td>
                <select 
                className="form-select" 
                name="remark_1" 
                id="remark1"
                >
                <option value="">[---Select---]</option>
                <option value="Price is Too Low">Price is Too Low</option>
                <option value="Price is too High">Price is too High</option>
                <option value="Price does not match with unit">Price does not match with unit</option>
                <option value="Price does not match with variety">Price does not match with variety</option>
                <option value="Other">Other</option></select>
                </td>
            </tr>
          </tbody>    

               </table>
              </div>
                  <div className="row">
                    <div className="col-12 text-center pt-3">
                  
                    <button
                      onClick={(e) => handleSubmitForm(e, 'SAVE')}
                      type="button"
                      className="btn btn_orange mx-1"
                      >Save
                    </button>
                  
                    <button
                      onClick={(e) => handleSubmitForm(e, 'ACCEPT')}
                      type="submit"
                      className="btn btn_orange mx-1"
                      >Submit
                    </button>
                


                    <button 
                      type="reset" 
                      className="btn btn_orange mx-1" 
                      onClick={handleResetForm} 
                      >
                      Reset
                    </button>
                    <button 
                      type="button" 
                      className="btn btn_orange mx-1" 
                      onClick={(e)=>( navigate("/dashboard"))}
                      >
                      Cancel
                    </button>
                </div>
                  </div>
            </div>
               
         )
         }
    </div>
     </div>
    
     </>
  )
}

export default PriceAgricultureParityFormMiscellaneous